import { PAGE_MODE } from "../../../constants/constants";
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../framework/form/FormFw";
import { MessageUtil } from "../../../util/MessageUtil";
import { BasePage } from "../../../framework/pages/BasePage";
import GridFw, { COLUMN_DEFAULT } from "../../../framework/grid/GridFw";
import { S3Util } from '../../../util/S3Util';

class OtrosDatosModalMeteorologico extends BasePage {
  renderPage(pageApi) {  
    const getForm = () => pageApi.getComponent("form");
    const getForm3 = () => pageApi.getComponent("form3");
    const getGrid12 = () => pageApi.getComponent("grid12");
    const getGrid13 = () => pageApi.getComponent("grid13");
    const getGridObservaciones = () => pageApi.getComponent("gridObservaciones");
 
    const getFormS3AdjuntosInforme = () => pageApi.getComponent("formS3AdjuntosInforme");
    const getGridAdjuntosInforme = () => pageApi.getComponent("gridAdjuntosInforme");

    console.log(pageApi);
 
    const formConfig3 = {
      layout: "vertical",
      title: "Procedimiento de muestreo utilizado",
      autoLoad: true,
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 949,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {   
          debugger;
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, ""); 
            } 
        },     
        params: { ID_CADENA: pageApi.getParamId() },
      
      },
      fields: [
        {
          label: "  ",
          fields: [
             {name: 'nro_ss_cadena', label: ' ',column: 4,readOnly: true} ,
            {
              type: "select",
              name: "PLAN_PROCEDIMIENTO",
              label: "Plan / Procedimiento",
              column: 5,
              load: {
                queryId: 910,
                params: { ID_CADENA: pageApi.getParamId() },
              },
              search: true,
            },
          ],
        },
        {
          label: "Datos para emision de Informe",
          fields: [
            { type: "hidden", name: "id_empresa" },
            {
              type: "select",
              name: "id_titular",
              label: "Títular del Informe",
              column: 4,
              load: { queryId: 623 },
              parents: [
                { name: "id_empresa", paramName: "id_empresa", required: true },
              ],
              search: true,
            },
            {
              type: "select",
              name: "id_tipo_informe",
              label: "Tipo de Informe",
              column: 4,
              load: {
                queryId: 565,
                fnOk: (resp) => {
                  if (pageApi.getPageMode() === PAGE_MODE.NEW) {
                    const findOption = resp?.dataList.find(
                      (data) => data.value === 18,
                    );
                    if (findOption) {
                      getForm3().values.id_tipo_informe = findOption.value;
                    }
                  }
                },
              },
            },
          ],
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };
 
    const fnNew12 = () => {
      getGrid12().addItem({}, true);
    };

    const fnDelete12 = (value, row, index) => {
      getGrid12().deleteItem(row.key);
    };

    const fnNew13 = () => {
      getGrid13().addItem({}, true);
    };

    const fnDelete13 = (value, row, index) => {
      getGrid13().deleteItem(row.key);
    };    

    const form = {
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 354,
        params: {
          ID_CADENA: pageApi.getParamId(),
        },
      },
      title: "",
      collapsible: true,
      fields: [],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const gridBarHeaderButtonconfig12 = {
      fields: [
        {
          ...BUTTON_DEFAULT.NEW,
          label: `Adicionar Inspector`,
          onClick: fnNew12,
        },
      ],
    };

    let array_inspector = [];
    const gridConfig12 = {
      title: "Datos del Inspector responsable del muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      rowId: "ID_INSPECTOR_CAMPO",
      barHeader: gridBarHeaderButtonconfig12,
      load: {
        queryId: 793,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 794,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, ""); 
            } 
        }, 
      },
      dataOptions: {
        out: { includeLabel: true },
      },
      fields: [
        {
          type: "select",
          name: "ID_INSPECTOR",
          label: "Inspector",
          labelName: "NOMBRE_INSPECTOR",
          column: 4,
          search: true,
          allowClear: true,
          editable: true,
          width: 100,
          load: {
            queryId: 913,
            params: {
              id_cadena: pageApi.getParamId(),
            },
            fnOk: (resp) => {
              //console.log(resp.dataList)
              array_inspector = resp.dataList;
            },
          },
          onChange: (value, values, formApi) => {
            let obj = array_inspector.filter((data) => data.value === value);

            obj.forEach((x) => {
              console.log(x.value);
              getGrid12().itemEditing.ID_INSPECTOR = x.value;
              console.log(getGrid12().itemEditing.value);
            });
            getGrid12().refresh();
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete12,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const fnNew5 = () => {
      getGridObservaciones().addItem({}, true);
    };

    const fnDelete5 = (value, row, index) => {
      getGridObservaciones().deleteItem(row.key);
    };

    const gridBarHeaderButtonconfig5 = {
      fields: [
        { ...BUTTON_DEFAULT.NEW, label: `Agregar Item`, onClick: fnNew5 },
      ],
    };

    let array_lider = [];
    const gridBarHeaderButtonconfig13 = {
      fields: [
        {
          ...BUTTON_DEFAULT.NEW,
          label: `Adicionar Inspector`,
          onClick: fnNew13,
        },
      ],
    };

    const gridConfig13 = {
      title: "Datos del Inspector Lider del muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      rowId: "ID_LIDER_CAMPO",
      barHeader: gridBarHeaderButtonconfig13,
      load: {
        queryId: 985,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 986,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, ""); 
            } 
        }, 
      },
      dataOptions: {
        out: { includeLabel: true },
      },
      fields: [
        {
          type: "select",
          name: "ID_INSPECTOR",
          label: "Inspector",
          labelName: "NOMBRE_INSPECTOR",
          column: 4,
          search: true,
          allowClear: true,
          editable: true,
          width: 100,
          load: {
            queryId: 913,
            params: {
              id_cadena: pageApi.getParamId(),
            },
            fnOk: (resp) => {
              //console.log(resp.dataList)
              array_lider = resp.dataList;
            },
          },
          onChange: (value, values, formApi) => {
            let obj = array_lider.filter((data) => data.value === value);

            obj.forEach((x) => {
              console.log(x.value);
              getGrid13().itemEditing.ID_INSPECTOR = x.value;
              console.log(getGrid13().itemEditing.value);
            });
            getGrid13().refresh();
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete13,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };    

    const gridObservaciones = {
      title: "Observaciones",
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      rowId: "ID_OBSERVACION",
      barHeader: gridBarHeaderButtonconfig5,
      scroll: {
        x: "auto",
      },
      load: {
        queryId: 421,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 418,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {   
          if (resp?.dataObject == 1) {
          MessageUtil("error", resp.message, "");
          }
          else { 
          MessageUtil("success", resp.message, ""); 
          } 
        },         
      },
      fields: [
        {
          type: "select",
          name: "TIPO_OBSERVACION",
          label: "Tipo",
          labelName: "DESCRIPCION",
          editable: true,
          load: { queryId: 422 },
        },
        { name: "OBSERVACION", label: "Observación", editable: true },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete5,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };
 
    const formConfigS3AdjuntosInforme = {
      title: 'Adjuntar imagen rosa de viento', 
      fields: [
          {
              type: 'dragger',
              name: 'archivo',
              label: 'Arrastra y suelta tus archivos',
              multiple: 4,
              folder: 'bvdigital-repository-ma-per-pr/solicitud-servicio/adjunto-informe',
              onChange: (value, values) => {
                  async function getUrl(file_name, ruta) {
                      let result = await S3Util.getUrlS3(file_name, ruta);
                      return result;
                  }
                  let lst = getFormS3AdjuntosInforme().getFieldApi('archivo').getFileList();
                  if (value && value.length > 0) {
                      lst.forEach(file => {
                          getUrl(file.fileId, 'bvdigital-repository-ma-per-pr/solicitud-servicio/adjunto-informe').then(urlComplete => {
                              getGridAdjuntosInforme().addItem({ 
                                  FILENAME: file.fileId, 
                                  originalName: file.name, 
                                  TYPE_FILE: file.type, 
                                  PATH_FILE: 'bvdigital-repository-ma-per-pr/solicitud-servicio/adjunto-informe'
                              }, true);
                          })
                      });
                  }
                  getFormS3AdjuntosInforme().reset();
              },
              column: 12
          },
      ]
    };

    const gridConfigAdjuntosInforme = {
      collapsible: true,
      showIndex: true,
      autoLoad: true,
      rowId: 'ID_FILE_AI',
      pagination: {
          server: true
      },
      load: {
          queryId: 704,
          params: { ID_CADENA: pageApi.getParamId() },
          hideMessageError: true,
      },
      save: {
          queryId: 705
      },
      fields: [
          { name: 'FILENAME', label: 'Archivo', width: 200 },
          { name: 'TYPE_FILE', label: 'Tipo', width: 100 },
          { name: 'DESCRIPCION', label: 'Descripcion', editable: true },
          {
              ...COLUMN_DEFAULT.VIEW, 
              onClick: (value, row, index) => {
                  S3Util.donwload(row.FILENAME, 'bvdigital-repository-ma-per-pr/solicitud-servicio/adjunto-informe');
              }
          },
          {
              ...COLUMN_DEFAULT.DELETE,
              process: {
                  fnOk: (resp) => getGridAdjuntosInforme().load(),
                  filter: (value, row, index) => ({ queryId: 706, params: { ID: row.ID_FILE } })
              }
          }
      ],
      onComponentLoad: (formApi, pageApi) => {
          if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const barButtonFooterdatos_servicio = {
      fields: [
        {
          ...BUTTON_DEFAULT.RETURN,
          label: "Retornar Inicio",
          onClick: () => {
            const pathBack = this.props?.history?.location?.state?.from 
              || `/solicitudes-asignadas/solicitudes-asignadas/${pageApi.name.id_ss}`;
            this.props.history.push(pathBack);
          },
        },
        {
          ...BUTTON_DEFAULT.SAVE,
          label: "Guardar",
          onClick: () => {
            getForm3().save();
            getGrid12().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGrid13().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridObservaciones().save({ params: { ID_CADENA: pageApi.getParamId() } }); 
            getGridAdjuntosInforme().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridAdjuntosInforme().refresh()
            MessageUtil("success", "Se actualizó correctamente");
          },
        },
        {
          ...BUTTON_DEFAULT.NEXT,
          label: "Continuar",
          onClick: () => {
            getForm3().save();
            getGrid12().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGrid13().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridObservaciones().save({ params: { ID_CADENA: pageApi.getParamId() } }); 
            getGridAdjuntosInforme().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridAdjuntosInforme().refresh()
            this.props.history.push(
              `/solicitudes-asignadas/solicitudes-asignadas/${getForm3()?.getData()?.ID_SOLICITUD_SERVICIO}`,
            );
            MessageUtil("success", "Se actualizó correctamente");
          },
        },
      ],
    };

    return (
      <>
        <div style={{ display: "none" }}>
          <FormFw name="form" getParentApi={pageApi.getApi} config={form} />
        </div>
        <FormFw
          name="form3"
          getParentApi={pageApi.getApi}
          config={formConfig3}
        />
        <GridFw
          name="gridObservaciones"
          getParentApi={pageApi.getApi}
          config={gridObservaciones}
        />
        <GridFw
          name="grid12"
          getParentApi={pageApi.getApi}
          config={gridConfig12}
        />
        <GridFw
          name="grid13"
          getParentApi={pageApi.getApi}
          config={gridConfig13}
        />
         
        <FormFw
          name="formS3AdjuntosInforme"
          getParentApi={pageApi.getApi}
          config={formConfigS3AdjuntosInforme}
        />
        <GridFw
          name="gridAdjuntosInforme"
          getParentApi={pageApi.getApi}
          config={gridConfigAdjuntosInforme}
        />

        <BarButtonFw
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooterdatos_servicio}
        />
      </>
    );
  }
}
export default OtrosDatosModalMeteorologico;